import { Button, ModalOverlay } from './ui';
import { dismissPendingApprovalPrompt } from '../auth';

export function PendingApprovalModal({
  userId,
  onClose,
}: {
  userId: string;
  onClose: () => void;
}) {
  const finish = () => {
    dismissPendingApprovalPrompt(userId);
    onClose();
  };

  return (
    <ModalOverlay>
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="pending-approval-title"
        aria-describedby="pending-approval-body"
        className="app-dialog bg-surface shadow-pop w-full max-w-md p-6 sm:p-8"
      >
        <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-ink-faint mb-2">
          Account
        </p>
        <h2 id="pending-approval-title" className="font-heading text-xl font-bold text-ink mb-3">
          Waiting for admin approval
        </h2>
        <p id="pending-approval-body" className="text-sm text-ink-soft mb-6">
          You’re in the club. An admin still needs to check your university ID before internships and mentor questions open. Look around, pick a plan if you want, and we’ll email you when you’re approved.
        </p>
        <Button className="w-full" size="lg" onClick={finish}>
          Continue in the club
        </Button>
      </div>
    </ModalOverlay>
  );
}
